import { useContext } from 'react';
import { ArrayFieldItemStateContext } from '../Context.js';

function useArrayFieldItemState() {
  return useContext(ArrayFieldItemStateContext);
}

export { useArrayFieldItemState };
